import { render, staticRenderFns } from "./ProjectReportsTable.vue?vue&type=template&id=78f68f26&scoped=true&"
import script from "./ProjectReportsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectReportsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReportsTable.vue?vue&type=style&index=0&id=78f68f26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f68f26",
  null
  
)

export default component.exports